import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from '../organisms/Table.css';
import TableRowActions from './TableRowActions';
import Tooltip from '../molecules/Tooltip';
import CellLoader from './CellLoader';

const TableCellText = ({
    value,
    index,
    isEditable = false,
    onDelete,
    onAdd,
    getIsAddDisabled = () => false,
    getIsDeleteDisabled = () => false,
    addDisabledTooltip,
    getIsShowAdd = () => true,
    getIsShowDelete = () => true,
    showRowActions = false,
    className,
    tdStyle = {},
    tooltip = '',
    cellTooltipKey,
    isLoading = false,
    loaderClass = '',
}) => {
    return (
        <td className={classNames(css.rowIndexCell, className)} style={tdStyle}>
            {isLoading ? (
                <CellLoader loaderClass={loaderClass} />
            ) : (
                <>
                    <Tooltip
                        titleTranslationKey={cellTooltipKey}
                        disabled={!(tooltip || cellTooltipKey)}
                        title={tooltip || ''}
                    >
                        {value}
                    </Tooltip>
                    {isEditable && showRowActions && (
                        <TableRowActions
                            onAdd={() => onAdd(index)}
                            onDelete={() => onDelete(index)}
                            isDeleteDisabled={getIsDeleteDisabled(index)}
                            isAddDisabled={getIsAddDisabled(index)}
                            addDisabledTooltip={addDisabledTooltip}
                            isShowAdd={getIsShowAdd(index)}
                            isShowDelete={getIsShowDelete(index)}
                        />
                    )}
                </>
            )}
        </td>
    );
};

TableCellText.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    index: PropTypes.number,
    isEditable: PropTypes.bool,
    onDelete: PropTypes.func,
    onAdd: PropTypes.func,
    getIsAddDisabled: PropTypes.func,
    getIsDeleteDisabled: PropTypes.func,
    showRowActions: PropTypes.bool,
    addDisabledTooltip: PropTypes.string,
    getIsShowAdd: PropTypes.func,
    getIsShowDelete: PropTypes.func,
    className: PropTypes.string,
    tdStyle: PropTypes.objectOf(PropTypes.any),
    tooltip: PropTypes.string,
    cellTooltipKey: PropTypes.string,
    isLoading: PropTypes.bool,
    loaderClass: PropTypes.string,
};

export default TableCellText;
